export default __webpack_public_path__ + "20a201b7a62508a9df15d9741ff36b7c.jpg";